'use strict';

var cov_1xu43oabe2 = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\report_calendar\\report_calendarCtrl.js',
      hash = 'cdfd6345bfbe6faf3bd3476020aeaa66a9653d39',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\report_calendar\\report_calendarCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 0
        },
        end: {
          line: 115,
          column: 3
        }
      },
      '1': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 37
        }
      },
      '2': {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 8,
          column: 3
        }
      },
      '3': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 11
        }
      },
      '4': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 27
        }
      },
      '5': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 27
        }
      },
      '6': {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 36
        }
      },
      '7': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 18
        }
      },
      '8': {
        start: {
          line: 13,
          column: 21
        },
        end: {
          line: 13,
          column: 62
        }
      },
      '9': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 19,
          column: 4
        }
      },
      '10': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 25
        }
      },
      '11': {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 64,
          column: 4
        }
      },
      '12': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 24,
          column: 5
        }
      },
      '13': {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 13
        }
      },
      '14': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 28
        }
      },
      '15': {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 25
        }
      },
      '16': {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      '17': {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 33,
          column: 9
        }
      },
      '18': {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 48,
          column: 7
        }
      },
      '19': {
        start: {
          line: 35,
          column: 19
        },
        end: {
          line: 35,
          column: 83
        }
      },
      '20': {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 54
        }
      },
      '21': {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 47,
          column: 11
        }
      },
      '22': {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 63,
          column: 7
        }
      },
      '23': {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 58,
          column: 7
        }
      },
      '24': {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 57,
          column: 9
        }
      },
      '25': {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 56,
          column: 11
        }
      },
      '26': {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 54,
          column: 59
        }
      },
      '27': {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 55,
          column: 18
        }
      },
      '28': {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 31
        }
      },
      '29': {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 22
        }
      },
      '30': {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 72,
          column: 4
        }
      },
      '31': {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 27
        }
      },
      '32': {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 46
        }
      },
      '33': {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      '34': {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 49
        }
      },
      '35': {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 31
        }
      },
      '36': {
        start: {
          line: 73,
          column: 2
        },
        end: {
          line: 77,
          column: 4
        }
      },
      '37': {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 32
        }
      },
      '38': {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 32
        }
      },
      '39': {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 20
        }
      },
      '40': {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 85,
          column: 4
        }
      },
      '41': {
        start: {
          line: 79,
          column: 22
        },
        end: {
          line: 79,
          column: 47
        }
      },
      '42': {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 83,
          column: 5
        }
      },
      '43': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 13
        }
      },
      '44': {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 20
        }
      },
      '45': {
        start: {
          line: 86,
          column: 2
        },
        end: {
          line: 111,
          column: 4
        }
      },
      '46': {
        start: {
          line: 87,
          column: 17
        },
        end: {
          line: 87,
          column: 20
        }
      },
      '47': {
        start: {
          line: 91,
          column: 22
        },
        end: {
          line: 91,
          column: 47
        }
      },
      '48': {
        start: {
          line: 92,
          column: 20
        },
        end: {
          line: 92,
          column: 62
        }
      },
      '49': {
        start: {
          line: 93,
          column: 21
        },
        end: {
          line: 99,
          column: 5
        }
      },
      '50': {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 28
        }
      },
      '51': {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 110,
          column: 7
        }
      },
      '52': {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 107,
          column: 7
        }
      },
      '53': {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 106,
          column: 9
        }
      },
      '54': {
        start: {
          line: 104,
          column: 10
        },
        end: {
          line: 104,
          column: 42
        }
      },
      '55': {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 105,
          column: 16
        }
      },
      '56': {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 108,
          column: 31
        }
      },
      '57': {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 109,
          column: 22
        }
      },
      '58': {
        start: {
          line: 112,
          column: 2
        },
        end: {
          line: 114,
          column: 5
        }
      },
      '59': {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 20
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 56
          },
          end: {
            line: 4,
            column: 57
          }
        },
        loc: {
          start: {
            line: 4,
            column: 170
          },
          end: {
            line: 115,
            column: 1
          }
        },
        line: 4
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 21,
            column: 18
          },
          end: {
            line: 21,
            column: 19
          }
        },
        loc: {
          start: {
            line: 21,
            column: 30
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 21
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 50,
            column: 161
          },
          end: {
            line: 50,
            column: 162
          }
        },
        loc: {
          start: {
            line: 50,
            column: 169
          },
          end: {
            line: 63,
            column: 5
          }
        },
        line: 50
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 65,
            column: 16
          },
          end: {
            line: 65,
            column: 17
          }
        },
        loc: {
          start: {
            line: 65,
            column: 32
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 65
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 73,
            column: 18
          },
          end: {
            line: 73,
            column: 19
          }
        },
        loc: {
          start: {
            line: 73,
            column: 30
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 73
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 78,
            column: 18
          },
          end: {
            line: 78,
            column: 19
          }
        },
        loc: {
          start: {
            line: 78,
            column: 30
          },
          end: {
            line: 85,
            column: 3
          }
        },
        line: 78
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 86,
            column: 20
          },
          end: {
            line: 86,
            column: 21
          }
        },
        loc: {
          start: {
            line: 86,
            column: 32
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 86
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 101,
            column: 125
          },
          end: {
            line: 101,
            column: 126
          }
        },
        loc: {
          start: {
            line: 101,
            column: 133
          },
          end: {
            line: 110,
            column: 5
          }
        },
        line: 101
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 112,
            column: 41
          },
          end: {
            line: 112,
            column: 42
          }
        },
        loc: {
          start: {
            line: 112,
            column: 47
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 112
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        }, {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        }],
        line: 6
      },
      '1': {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }],
        line: 22
      },
      '2': {
        loc: {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 22,
            column: 46
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 22,
            column: 26
          }
        }, {
          start: {
            line: 22,
            column: 30
          },
          end: {
            line: 22,
            column: 46
          }
        }],
        line: 22
      },
      '3': {
        loc: {
          start: {
            line: 34,
            column: 47
          },
          end: {
            line: 34,
            column: 87
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 34,
            column: 47
          },
          end: {
            line: 34,
            column: 66
          }
        }, {
          start: {
            line: 34,
            column: 70
          },
          end: {
            line: 34,
            column: 87
          }
        }],
        line: 34
      },
      '4': {
        loc: {
          start: {
            line: 34,
            column: 91
          },
          end: {
            line: 34,
            column: 127
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 34,
            column: 91
          },
          end: {
            line: 34,
            column: 108
          }
        }, {
          start: {
            line: 34,
            column: 112
          },
          end: {
            line: 34,
            column: 127
          }
        }],
        line: 34
      },
      '5': {
        loc: {
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 56,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 56,
            column: 11
          }
        }, {
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 56,
            column: 11
          }
        }],
        line: 53
      },
      '6': {
        loc: {
          start: {
            line: 53,
            column: 14
          },
          end: {
            line: 53,
            column: 104
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 53,
            column: 14
          },
          end: {
            line: 53,
            column: 43
          }
        }, {
          start: {
            line: 53,
            column: 47
          },
          end: {
            line: 53,
            column: 75
          }
        }, {
          start: {
            line: 53,
            column: 79
          },
          end: {
            line: 53,
            column: 104
          }
        }],
        line: 53
      },
      '7': {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 68
      },
      '8': {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 83,
            column: 5
          }
        }],
        line: 81
      },
      '9': {
        loc: {
          start: {
            line: 98,
            column: 10
          },
          end: {
            line: 98,
            column: 39
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 98,
            column: 10
          },
          end: {
            line: 98,
            column: 34
          }
        }, {
          start: {
            line: 98,
            column: 38
          },
          end: {
            line: 98,
            column: 39
          }
        }],
        line: 98
      },
      '10': {
        loc: {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        }, {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        }],
        line: 103
      },
      '11': {
        loc: {
          start: {
            line: 103,
            column: 12
          },
          end: {
            line: 103,
            column: 132
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 103,
            column: 12
          },
          end: {
            line: 103,
            column: 50
          }
        }, {
          start: {
            line: 103,
            column: 54
          },
          end: {
            line: 103,
            column: 92
          }
        }, {
          start: {
            line: 103,
            column: 96
          },
          end: {
            line: 103,
            column: 132
          }
        }],
        line: 103
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1xu43oabe2.s[0]++;
/**
 * Created by BKSB on 08/03/2017.
 */
angular.module('app').controller('report_calendarCtrl', function ($scope, $deltaReportType, $deltaActor, SweetAlert, $rootScope, $translate, $deltadate, $CRUDService, $filter) {
  cov_1xu43oabe2.f[0]++;
  cov_1xu43oabe2.s[1]++;

  $rootScope.processPageRight('5_2');
  cov_1xu43oabe2.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_1xu43oabe2.b[0][0]++;
    cov_1xu43oabe2.s[3]++;

    return;
  } else {
    cov_1xu43oabe2.b[0][1]++;
  }
  cov_1xu43oabe2.s[4]++;
  $scope.listProjects = [];
  cov_1xu43oabe2.s[5]++;
  $scope.PATH = 'Calendar';
  cov_1xu43oabe2.s[6]++;
  $deltaActor.addController($scope);
  cov_1xu43oabe2.s[7]++;
  $scope.step = 1;
  var actualYear = (cov_1xu43oabe2.s[8]++, $deltadate.format(Date.newDate(), 'yyyy'));
  cov_1xu43oabe2.s[9]++;
  $scope.choise = {
    begin: Date.newDate(actualYear, 0, 1),
    end: Date.newDate(actualYear, 11, 31),
    editItem: null,
    editing: false
  };
  cov_1xu43oabe2.s[10]++;
  $scope.invitation = {};
  cov_1xu43oabe2.s[11]++;
  $scope.getAll = function () {
    cov_1xu43oabe2.f[1]++;
    cov_1xu43oabe2.s[12]++;

    if ((cov_1xu43oabe2.b[2][0]++, !this.choise.begin) || (cov_1xu43oabe2.b[2][1]++, !this.choise.end)) {
      cov_1xu43oabe2.b[1][0]++;
      cov_1xu43oabe2.s[13]++;

      return;
    } else {
      cov_1xu43oabe2.b[1][1]++;
    }
    cov_1xu43oabe2.s[14]++;
    $scope.isloading = true;
    cov_1xu43oabe2.s[15]++;
    $scope.listData = [];
    cov_1xu43oabe2.s[16]++;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = $scope.listData_reportType_bksb[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;
        cov_1xu43oabe2.s[17]++;

        $scope.listData.push({
          LIBELLE_TYPE: el.LIBELLE_TYPE,
          IDACTEURS: el.IDACTEURS,
          CODE: el.id,
          type: 1
        });
        cov_1xu43oabe2.s[18]++;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = $deltadate.getPeriods((cov_1xu43oabe2.b[3][0]++, this.choise.begin.d) || (cov_1xu43oabe2.b[3][1]++, this.choise.begin), (cov_1xu43oabe2.b[4][0]++, this.choise.end.d) || (cov_1xu43oabe2.b[4][1]++, this.choise.end), el.PERIODE_RAPPORT - 0)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var elp = _step4.value;

            var dp = (cov_1xu43oabe2.s[19]++, Date.newDate(elp.year, elp.index * (12 / el.PERIODE_RAPPORT), 1));
            cov_1xu43oabe2.s[20]++;
            dp.setDate(dp.getDate() + el.DELAIS_PROD - 1);
            cov_1xu43oabe2.s[21]++;
            $scope.listData.push({
              period: elp.label,
              real: null,
              LIBELLE_TYPE: el.LIBELLE_TYPE,
              IDACTEURS: el.IDACTEURS,
              CODE: el.id,
              type: 2,
              year: elp.year,
              prevu: dp,
              num: elp.index
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    cov_1xu43oabe2.s[22]++;
    $CRUDService.getAll($scope.PATH, { get: 'all_p', b: $deltadate.format(this.choise.begin, 'yyyy-mm-dd'), e: $deltadate.format(this.choise.end, 'yyyy-mm-dd') }, function (data) {
      cov_1xu43oabe2.f[2]++;
      cov_1xu43oabe2.s[23]++;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var elr = _step2.value;
          cov_1xu43oabe2.s[24]++;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = $scope.listData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var el = _step3.value;
              cov_1xu43oabe2.s[25]++;

              if ((cov_1xu43oabe2.b[6][0]++, elr.IDTYPE_RAPPORT == el.CODE) && (cov_1xu43oabe2.b[6][1]++, elr.ANNEE_RAPPORT == el.year) && (cov_1xu43oabe2.b[6][2]++, elr.NUM_PERIODE == el.num)) {
                cov_1xu43oabe2.b[5][0]++;
                cov_1xu43oabe2.s[26]++;

                el.real = Date.newDate(elr.DATE_RELLE_RAPPORT);
                cov_1xu43oabe2.s[27]++;
                break;
              } else {
                cov_1xu43oabe2.b[5][1]++;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      cov_1xu43oabe2.s[28]++;
      $scope.isloading = false;
      cov_1xu43oabe2.s[29]++;
      $scope.cancel();
      // $scope.listData=data;
    });
  };
  cov_1xu43oabe2.s[30]++;
  $scope.edit = function (item) {
    cov_1xu43oabe2.f[3]++;
    cov_1xu43oabe2.s[31]++;

    $scope.invitation = {};
    cov_1xu43oabe2.s[32]++;
    this.choise.editItem = angular.copy(item);
    cov_1xu43oabe2.s[33]++;
    if (!this.choise.editItem.real) {
      cov_1xu43oabe2.b[7][0]++;
      cov_1xu43oabe2.s[34]++;

      this.choise.editItem.real = Date.newDate();
    } else {
      cov_1xu43oabe2.b[7][1]++;
    }
    cov_1xu43oabe2.s[35]++;
    this.choise.editing = true;
  };
  cov_1xu43oabe2.s[36]++;
  $scope.cancel = function () {
    cov_1xu43oabe2.f[4]++;
    cov_1xu43oabe2.s[37]++;

    this.choise.editItem = null;
    cov_1xu43oabe2.s[38]++;
    this.choise.editing = false;
    cov_1xu43oabe2.s[39]++;
    $scope.step = 1;
  };
  cov_1xu43oabe2.s[40]++;
  $scope.nextEl = function () {
    cov_1xu43oabe2.f[5]++;

    var Dateparam = (cov_1xu43oabe2.s[41]++, this.choise.editItem.real);

    cov_1xu43oabe2.s[42]++;
    if (!Dateparam) {
      cov_1xu43oabe2.b[8][0]++;
      cov_1xu43oabe2.s[43]++;

      return;
    } else {
      cov_1xu43oabe2.b[8][1]++;
    }
    cov_1xu43oabe2.s[44]++;
    $scope.step = 2;
  };
  cov_1xu43oabe2.s[45]++;
  $scope.validate = function () {
    cov_1xu43oabe2.f[6]++;

    var list = (cov_1xu43oabe2.s[46]++, '0');
    /* for(var el in $scope.invitation){
        if($scope.invitation[el]) list+=";"+el;
    } */
    var Dateparam = (cov_1xu43oabe2.s[47]++, this.choise.editItem.real);
    var datform = (cov_1xu43oabe2.s[48]++, $deltadate.format(Dateparam, 'yyyy-mm-dd'));
    var saveData = (cov_1xu43oabe2.s[49]++, {
      ANNEE_RAPPORT: this.choise.editItem.year,
      DATE_RELLE_RAPPORT: datform,
      IDTYPE_RAPPORT: this.choise.editItem.CODE,
      NUM_PERIODE: this.choise.editItem.num,
      id: (cov_1xu43oabe2.b[9][0]++, this.choise.editItem.idP) || (cov_1xu43oabe2.b[9][1]++, 0)
    });
    cov_1xu43oabe2.s[50]++;
    $scope.isloading = true;
    cov_1xu43oabe2.s[51]++;
    $CRUDService.save($scope.PATH, { action: 'MiseAJour', valeur: $filter('json')(saveData), l: $filter('json')(list + ';') }, function (data) {
      cov_1xu43oabe2.f[7]++;
      cov_1xu43oabe2.s[52]++;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = $scope.listData[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var el = _step5.value;
          cov_1xu43oabe2.s[53]++;

          if ((cov_1xu43oabe2.b[11][0]++, $scope.choise.editItem.CODE == el.CODE) && (cov_1xu43oabe2.b[11][1]++, $scope.choise.editItem.year == el.year) && (cov_1xu43oabe2.b[11][2]++, $scope.choise.editItem.num == el.num)) {
            cov_1xu43oabe2.b[10][0]++;
            cov_1xu43oabe2.s[54]++;

            el.real = Date.newDate(datform);
            cov_1xu43oabe2.s[55]++;
            break;
          } else {
            cov_1xu43oabe2.b[10][1]++;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      cov_1xu43oabe2.s[56]++;
      $scope.isloading = false;
      cov_1xu43oabe2.s[57]++;
      $scope.cancel();
    });
  };
  cov_1xu43oabe2.s[58]++;
  $deltaReportType.addController($scope, function () {
    cov_1xu43oabe2.f[8]++;
    cov_1xu43oabe2.s[59]++;

    $scope.getAll();
  });
});